export const twitter = {
  twitter: {
    shape:
      '<path fill="#3d3d3d" d="M21.18 7.76h2.75l-6.02 6.98L25 24.25h-5.55l-4.36-5.77-4.97 5.77H7.36l6.45-7.48L7 7.75h5.7l3.93 5.27 4.55-5.26zm-.97 14.81h1.53L11.87 9.34h-1.64l9.98 13.23z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
